import { useEffect, useState } from "react";
import AuthService from "../services/auth/AuthService";

const useMessierId = () => {
  const [messierId, setMessierId] = useState<string | null>(null);
  const [status, setStatus] = useState<string>("");

  const fetchData = async (ignore: boolean) => {
    setStatus("loading");
    const messierId = await AuthService.getMessierId();
    if (ignore) return;

    if (messierId) {
      setStatus("success");
      setMessierId(messierId);
    } else {
      setStatus("error");
    }
  };

  useEffect(() => {
    let ignore = false;
    fetchData(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  return { messierId, status };
};

export default useMessierId;
